import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex);

import settings from '/ps_settings/config.json';

const api_host = settings.API_HOST;
const api_port = settings.API_PORT;

let baseUrl;

if (api_port ) {
    baseUrl = `${api_host}:${api_port}`;
} else {
    baseUrl = `${api_host}`;
}

export const axiosApi = axios.create({
  baseURL: baseUrl,
  headers: {
    Authorization: 'Bearer {token}',
    'content-type': 'application/json'
  }
});


export const store = new Vuex.Store({
  strict: true,
  state: {
    errors: [],
    settings : settings,
    loading: true,
    axiosApi: axiosApi,
    funcAreaList: []
  }
})

